import { ButtonHTMLAttributes, ReactNode } from 'react'
import s from './ButtonSecondary.module.scss'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode
}

export const ButtonSecondary = ({ children, className, type = 'button', ...rest }: Props) => (
    <button {...rest} type={type} className={[s.button, className].filter(Boolean).join(' ')}>
        {children}
    </button>
)

export default ButtonSecondary
